import React, { useEffect, useState } from "react";
import { Input, notification, Progress } from "antd";
import { useNavigate } from "react-router-dom";

import { ArrowLeft } from "lucide-react";
import Icon from "../assets/Icon";
import Loader from "../components/Loader";
import Utils from "../utils/Utils";
import { forcePassSet } from "../api/common";
import WebUtils from "../utils/WebUtils";

function ForcePassRequired() {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [strength, setStrength] = useState(0);
  const [loadingMain, setLoadingMain] = useState(false);

  let userD = Utils.getUserDetail();

  const calculateStrength = (value) => {
    let score = 0;
    if (/[a-z]/.test(value)) score += 1;
    if (/[A-Z]/.test(value)) score += 1;
    if (/[0-9]/.test(value)) score += 1;
    if (/[^A-Za-z0-9]/.test(value)) score += 1;
    if (value.length >= 8) score += 1;
    setStrength(score);
  };

  const getStrengthColor = () => {
    if (strength <= 2) return "red";
    if (strength <= 4) return "orange";
    return "green";
  };

  const postPassword = () => {
    const encodedPassword = btoa(password);
    setLoadingMain(true);

    WebUtils.httpOperations(
      `${forcePassSet}?userIdentifier=${userD?.userIdentifier}&password=${encodedPassword}`,
      {},
      "POST",
    ).then(
      (response) => {
        setLoadingMain(false);
        if (response?.data?.resultStatusInfo.resultCode === "SUCCESS") {
          Utils.setUserDetail({ ...userD, userPasswordRequired: false });
          if (userD.userOnboardedRequired) {
            window.location.href = "/personal-details";
          } else {
            window.location.href = "/";
          }
        } else if (
          response.data.resultStatusInfo.resultCode == "PASSWORD_ALREADY_USED"
        ) {
          notification.error({
            message: response.data.resultStatusInfo?.message,
          });
        }
      },
      (error) => error,
    );
  };
  const handleSubmit = () => {
    postPassword();
  };

  const handleLogOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };

  return (
    <>
      {loadingMain && <Loader />}
      <div className="flex flex-col min-h-screen">
        <div className="py-[1rem] w-full px-3 md:w-[88%] mx-auto flex justify-between">
          <div className="sm:block flex justify-center">
            <Icon type="jobdrona-logo" width={30} height={32} />
          </div>

          <div className="flex text-base justify-center items-center gap-2">
            <ArrowLeft color="black" />{" "}
            <span className="text-[#475467] font-semibold">
              Back to{" "}
              <span
                onClick={handleLogOut}
                className="text-[#206DC5] underline cursor-pointer hover:brightness-125"
              >
                {" "}
                Log In
              </span>
            </span>
          </div>
        </div>
        <div className="flex-1 flex flex-col justify-center items-center">
          <div className="sm:w-[400px] w-full mx-auto p-6 rounded-2xl backdrop-blur-md bg-white/10 border  border-gray-300 shadow-lg text-gray-800">
            <h2 className="text-xl font-semibold mb-4 text-center">
              Set Up Password
            </h2>

            <div className="">
              <Input.Password
                placeholder="Enter password"
                size="large"
                value={password}
                onChange={(e) => {
                  const value = e.target.value;
                  setPassword(value);
                  calculateStrength(value);
                }}
                className="rounded-md"
              />

              <Progress
                percent={(strength / 5) * 100}
                showInfo={false}
                strokeColor={getStrengthColor()}
                trailColor="#e5e7eb"
                className="my-2"
              />

              {/* Password Requirements */}
              <ul className="text-sm text-gray-400 list-disc pl-5 space-y-1">
                <li className={/[A-Z]/.test(password) ? "text-green-400" : ""}>
                  At least one uppercase letter
                </li>
                <li className={/[a-z]/.test(password) ? "text-green-400" : ""}>
                  At least one lowercase letter
                </li>
                <li className={/[0-9]/.test(password) ? "text-green-400" : ""}>
                  At least one number
                </li>
                <li
                  className={
                    /[^A-Za-z0-9]/.test(password) ? "text-green-400" : ""
                  }
                >
                  At least one special character
                </li>
                <li className={password.length >= 8 ? "text-green-400" : ""}>
                  Minimum 8 characters
                </li>
              </ul>

              <Input.Password
                placeholder="Confirm password"
                size="large"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="mt-3 rounded-md bg-transparent border-gray-500"
              />

              {confirm && password !== confirm && (
                <p className="text-sm text-red-400">
                  ❌ Passwords do not match
                </p>
              )}

              <button
                onClick={handleSubmit}
                disabled={strength < 5 || password !== confirm || !password}
                className={`mt-4 w-full py-[9px] rounded-[9px] transition ${
                  strength < 5 || password !== confirm
                    ? "btn-disabled"
                    : "btn-blue"
                }`}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForcePassRequired;
